import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";
// import { Image_Fragment } from "./image";

export const Video_Fragment = graphqlShopifyStorefront(
  `
  fragment Video on Video {
    __typename
    alt
    id
    mediaContentType
    previewImageMasked: previewImage {
      ...Image
    }
    sources {
      format
      height
      mimeType
      url
      width
    }
  }
`,
  // [Image_Fragment],
);
